export enum HookTriggerEnum {
    Arrival = 'arrival',
    Departure = 'departure',
}
